module.exports = __webpack_public_path__ + "images/Ferrari-7260e8.png";